export default {
  verify: 'Verify',
  visitor: 'Visitor',
  worker: 'Worker',
  name: 'Name',
  company: 'Company',
  vistor_type: 'Type of visit',
};
